"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWidgetQs = void 0;
const qs_1 = require("./qs");
const qsAll_1 = require("./qsAll");
const qsOrThrowFit_1 = require("./qsOrThrowFit");
/**
 * Sets up query selector functions which target the
 * closest parent selected by `closest` to the
 * current script
 * @param closest Selector for the root of the widget
 * @returns query selectors for the widget
 */
const getWidgetQs = (closest) => {
    let widgetRootEl;
    if (typeof closest === "string") {
        if (!document.currentScript)
            throw new Error(`Error while setting up widget with root "${closest}": currentScript not supported`);
        widgetRootEl = document.currentScript.closest(closest);
        if (!widgetRootEl)
            throw new Error(`Error while setting up widget with root "${closest}": could not find root element`);
    }
    else
        widgetRootEl = closest;
    return {
        qs: (selector, target = widgetRootEl) => (0, qs_1.qs)(selector, target),
        qsAll: (selector, target = widgetRootEl) => (0, qsAll_1.qsAll)(selector, target),
        qsOrThrowFit: (selector, target = widgetRootEl) => (0, qsOrThrowFit_1.qsOrThrowFit)(selector, target),
        widgetRootEl,
    };
};
exports.getWidgetQs = getWidgetQs;
